"use strict";

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactHookForm = require("react-hook-form");
var _reactIntl = require("react-intl");
var _Box = _interopRequireDefault(require("@quintoandar/cozy-core/Box"));
var _proptypes = _interopRequireDefault(require("../Input/proptypes"));
var _ValidationErrors = _interopRequireDefault(require("../ValidationErrors"));
var _useValidation = _interopRequireDefault(require("../Form/hooks/useValidation"));
var _a11y = require("../Form/a11y");
var _excluded = ["name", "validators", "initialValue", "onChange", "onBlur", "variant", "children", "inputType", "required", "minLength", "maxLength", "intl"];
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) {
    if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
      var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
      i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
  }
  return n["default"] = e, t && t.set(e, n), n;
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
var InputController = function InputController(props) {
  var name = props.name,
    validators = props.validators,
    initialValue = props.initialValue,
    onChange = props.onChange,
    onBlur = props.onBlur,
    variant = props.variant,
    children = props.children,
    inputType = props.inputType,
    required = props.required,
    minLength = props.minLength,
    maxLength = props.maxLength,
    intl = props.intl,
    rest = _objectWithoutProperties(props, _excluded);
  var validationData = (0, _useValidation["default"])(name, intl, validators, {
    required: required,
    minLength: minLength,
    maxLength: maxLength
  }, [validators, required, minLength, maxLength]);
  if (!validationData) {
    return /*#__PURE__*/(0, _react.cloneElement)(children, props);
  }
  var rules = validationData.rules,
    errors = validationData.errors,
    control = validationData.control;
  var _useController = (0, _reactHookForm.useController)({
      name: name,
      control: control,
      rules: rules,
      defaultValue: initialValue
    }),
    _useController$field = _useController.field,
    ref = _useController$field.ref,
    internalChangeHandler = _useController$field.onChange,
    internalBlurHandler = _useController$field.onBlur,
    internalValue = _useController$field.value;
  var handleChange = function handleChange(e) {
    var val = typeof onChange === 'function' && onChange(e);
    internalChangeHandler(val || e);
  };
  var handleBlur = function handleBlur(e) {
    if (typeof onBlur === 'function') {
      onBlur(e);
    }
    internalBlurHandler(e);
  };
  var hasError = errors.length >= 1;
  var errorId = (0, _a11y.a11yErrorId)(name);
  var controlledElement = /*#__PURE__*/(0, _react.cloneElement)(children, _objectSpread({
    ref: ref,
    name: name,
    value: internalValue,
    onChange: handleChange,
    onBlur: handleBlur,
    error: hasError,
    maxLength: maxLength,
    'aria-required': required,
    'aria-describedby': errorId,
    'aria-invalid': hasError
  }, rest));
  return /*#__PURE__*/_react["default"].createElement(_Box["default"], null, controlledElement, /*#__PURE__*/_react["default"].createElement(_ValidationErrors["default"], {
    id: errorId,
    errors: errors,
    variant: variant
  }));
};
InputController.propTypes = process.env.NODE_ENV !== "production" ? {
  name: _propTypes["default"].string.isRequired,
  validators: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    rule: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].func]).isRequired,
    value: _propTypes["default"].any,
    message: _propTypes["default"].string.isRequired
  })),
  initialValue: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  onChange: _propTypes["default"].func,
  onBlur: _propTypes["default"].func,
  variant: _proptypes["default"],
  children: _propTypes["default"].node,
  inputType: _propTypes["default"].string,
  required: _propTypes["default"].bool,
  minLength: _propTypes["default"].number,
  maxLength: _propTypes["default"].number,
  intl: _propTypes["default"].object.isRequired
} : {};
var _default = exports["default"] = (0, _reactIntl.injectIntl)(InputController);